import { useParams } from "react-router-dom";
import { useGetInfo } from "./useGetInfo";
import { useEffect, useState } from "react";

export const useGetCheckoutPaymentProviders = () => {
  const params = useParams();
  const store_id = params?.store_id;
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const [allowedPaymentProviders, setAllowedPaymentProviders] = useState([]);

  useEffect(() => {
    const paymentProviders = [];

    // raven
    if (storeDetails?.support_raven_payment_on_checkout_flow)
      paymentProviders.push("raven");

    // interswitch
    if (storeDetails?.terminals?.find((terminal) => terminal?.use_on_checkout))
      paymentProviders.push("interswitch");

    setAllowedPaymentProviders(paymentProviders);
  }, []);

  return {
    hasAtleastOneProvider: allowedPaymentProviders?.length > 0,
    allowedPaymentProviders,
    setAllowedPaymentProviders,
  };
};
